import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router, RouterLink, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; import { StateService } from '../../service/state.service';
import { Subject } from 'rxjs';
import { StorageService } from '../../service/storage.service';
import { CartComponent } from '../cart/cart.component';
import { TOKEN } from '../../constants/constant';

@Component({
  selector: 'app-header',
  imports: [RouterModule, RouterLink, CommonModule, FormsModule, CartComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  isMenuOpen = false;
  count: number;

  constructor(private stateService: StateService, private localStorageService: StorageService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.router.events.subscribe((event) => {
        this.stateService.setIsMenuOpen(false)
        this.stateService.showCartSideBar(false)
    });

    this.stateService.isMenuOpen$.subscribe((res: boolean) => {
      this.isMenuOpen = res
    })
    this.getCartCount();
  }
  
  toggleMenu() {
    this.stateService.setIsMenuOpen(!this.isMenuOpen)
  }

  toggleCart() {
    this.stateService.showCartSideBar(true)
  }

  checkOpenSignIn() {
    if (this.localStorageService.getItem(TOKEN)) {
      this.router.navigate(['account']);
      return;
    }
    const queryParams: Params = { signIn: 1 };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });
  }

  unsubscribe$ = new Subject();

  getCartCount() {
    this.stateService.cartDetails$.subscribe((res: any) => {
      this.count = res?.length
    })
  }
}
